import { appointmentTypeLabel } from '@/utils/appointmentTypeLabel';

export interface AppointmentHoverSource {
  id?: string | null;
  type?: string | null;
  scheduledDate?: string | null;
  status?: string | null;
  frequency?: string | null;
  frequencyNumber?: number | null;
  cptCode?: string | null;
  createdAt?: string | null;
}

export interface AppointmentHoverRow {
  label: string;
  value: string;
}

function titled(value?: string | null): string {
  return appointmentTypeLabel(value);
}

function calendarDay(value?: string | null): string {
  if (!value?.trim()) return '';
  const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return value.trim();
  return `${match[2]}/${match[3]}/${match[1]}`;
}

export function appointmentFrequencyLabel(
  frequency?: string | number | null,
  frequencyNumber?: number | null
): string {
  const fromFrequency =
    typeof frequency === 'number'
      ? frequency
      : frequency != null && frequency.trim() !== '' && Number.isFinite(Number(frequency))
        ? Number(frequency)
        : null;
  const numeric =
    fromFrequency != null && Number.isFinite(fromFrequency)
      ? fromFrequency
      : typeof frequencyNumber === 'number' && Number.isFinite(frequencyNumber)
        ? frequencyNumber
        : null;
  if (numeric == null) return typeof frequency === 'string' ? frequency.trim() || '—' : '—';
  return `${numeric} day${numeric === 1 ? '' : 's'}`;
}

export function appointmentHoverContent(
  appointment: AppointmentHoverSource | null | undefined,
  transmissionId?: string | null
): { title: string; rows: AppointmentHoverRow[]; id: string } {
  return {
    title: titled(appointment?.type) || 'Appointment',
    rows: [
      { label: 'Scheduled date', value: calendarDay(appointment?.scheduledDate) || '—' },
      { label: 'Status', value: titled(appointment?.status) || '—' },
      {
        label: 'Frequency',
        value: appointmentFrequencyLabel(appointment?.frequency, appointment?.frequencyNumber)
      },
      { label: 'CPT code', value: appointment?.cptCode?.trim() || '—' },
      { label: 'Created date', value: calendarDay(appointment?.createdAt) || '—' },
      { label: 'Linked transmission', value: transmissionId?.trim() || '—' }
    ],
    id: appointment?.id?.trim() || ''
  };
}
